/**
 * Màn hình quản lý thông số
 */
import { memo } from "react";
import { Layout, Typography, Space } from "antd";
import ListParameter from "pages/Parameter/ListParameter/index";
const { Title } = Typography;
const { Content } = Layout;
function Parameter() {
  return (
    <Content
      className="custom-layout-content background-content-layout"
      style={{
        marginLeft: 24,
        marginTop: 16,
        marginRight: 24,
        // backgroundColor: "white",
      }}
    >
      <Space
        direction="vertical"
        style={{
          width: "100%",
        }}
        size={"large"}
      >
        <div className="space-between ">
          <Title style={{ marginBottom: 0 }} level={4}>
            Quản trị thông số
          </Title>
        </div>
        <ListParameter />
      </Space>
    </Content>
  );
}

export default memo(Parameter);
